import { View, Text } from "react-native";
import React from "react";
import { primary } from "../../../colors";

export default function MessageStatus({ time, status, meSender }) {
  
  return (
    <View
      style={{
        paddingHorizontal: 10,
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      {meSender && (
        <View
          style={{
            width: 10,
            height: 10,
            borderRadius: 10,
            backgroundColor: status === "read" ? primary : "#e4e3e3",
            margin: 1,
          }}
        ></View>
      )}
      {meSender && status === "read" && (
        <View
          style={{
            width: 10,
            height: 10,
            borderRadius: 10,
            backgroundColor: status === "read" ? primary : "#e4e3e3",
            margin: 1,
          }}
        ></View>
      )}
    </View>
  );
}
